module.exports = __webpack_public_path__ + "media/toolkits/COVID-desktop-ecosystem-24c048cf.jpg";